"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var brands = [
    {
        name: 'logo',
        label: 'Logo voor clubkanaal',
        type: 'logo',
        description: 'Dit logo wordt gebruikt op je clubkanaal pagina en de overzichtspagina’s.',
        extensions: ['.jpg', '.png'],
        recommendedSize: '400x400',
    },
    {
        name: 'icon',
        label: 'Club logo voor competitie',
        type: 'icon',
        description: 'Dit logo wordt gebruikt in de lijst met clubs in je competitie.',
        extensions: ['.png'],
        recommendedSize: '200x200',
    },
    {
        name: 'banner',
        type: 'banner',
        label: 'Banner voor je clubkanaal',
        description: 'Deze banner wordt bovenaan de pagina onder je logo geplaatst.',
        extensions: ['.jpg', '.png'],
        recommendedSize: '1600x500',
    },
    {
        name: 'watermark',
        label: 'Watermerk',
        type: 'watermark',
        description: 'Dit watermerk wordt getoond in de Eyecons video player tijdens het afspelen van je video’s en livestreams.',
        extensions: ['.jpg', '.png'],
        recommendedSize: '200x200',
    },
    {
        name: 'videowall_sponsor',
        type: 'banner',
        label: 'Videowall sponsor',
        description: 'Deze banner wordt getoond onder de Eyecons video player op je eigen videowall.',
    },
];
function Branding(_a) {
    var channel = _a.channel, onSubmit = _a.onSubmit, onChange = _a.onChange, onDelete = _a.onDelete, active = _a.active;
    return react_1.default.createElement("div", { className: 'storybook-channels-branding' }, brands.map(function (brand, index) { return react_1.default.createElement(storybook_1.Channels.Brand, { key: index, options: channel.data.options, submitting: channel.submitting && active === brand.name, value: channel.data[brand.name], brand: brand, onChange: function (file) { return onChange(brand.name, file); }, onSubmit: onSubmit, onDelete: function () { return onDelete(brand); } }); }));
}
exports.default = Branding;
Branding.propTypes = {};
Branding.defaultProps = {};
